import { useLocation } from "react-router-dom";
import Items from "../Aside/Components/Items";
import { useTicketCount } from "../../Context/TicketCountContext";

const determineActiveIndex = (pathname = "") => {
  const path = pathname.toLowerCase();
  if (path.startsWith("/accounts")) return 2;
  if (path.startsWith("/transactions")) return 3;
  if (path.startsWith("/challenges")) return 4;
  if (path.startsWith("/customers")) return 5;
  if (path.startsWith("/kyc")) return 6;
  if (path.startsWith("/support")) return 7;
  if (path.startsWith("/coupons")) return 8;
  // if (path.startsWith("/")) return 9;
  // if (path.startsWith("/")) return 10;
  if (path.startsWith("/announcements")) return 11;
  // if (path.startsWith("/")) return 12;
  // if (path.startsWith("/")) return 13;
  if (path.startsWith("/profile")) return 14;
  if (path.startsWith("/admins")) return 15;
  // if (path.startsWith("/")) return 16;
  if (path.startsWith("/trades")) return 17;
  if (path.startsWith("/sales-participation")) return 18;
  if (path.startsWith("/dollar")) return 19;
  return 1;
};

export default function ContainerHamburger({
  isCollapsed,
  onClose = () => {},
}) {
  const { pathname } = useLocation();
  const { ticketCount, haveNotifications } = useTicketCount();
  const activeIndex = determineActiveIndex(pathname);
  const handleCloseMenu = () => {
    if (isCollapsed) return;
    onClose();
  };

  return (
    <>
      <div
        onClick={handleCloseMenu}
        className={`md:hidden absolute right-0 top-0 z-[40] h-dvh bg-black/40 transition-none transition-opacity backdrop-blur-sm ${
          isCollapsed
            ? "w-0 opacity-0 pointer-events-none"
            : "w-dvw opacity-100 pointer-events-auto"
        }`}
      ></div>
      <aside
        className={`md:hidden absolute right-0 top-0 z-40 h-dvh flex flex-col gap-6 rounded-l-2xl drop-shadow-md bg-zi-bg2-light dark:bg-zi-bg2-dark ${
          isCollapsed ? "w-0 p-0 pt-20" : "w-[250px] p-3 pt-20"
        }`}
      >
        <div className="overflow-y-auto flex flex-col gap-6 p-0">
          <div className="flex flex-col gap-3">
            <Items
              svg_name="dashboard"
              title="میز کار"
              isActive={activeIndex === 1}
              href="/Dashboard"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
          </div>

          <div className="flex flex-col gap-3">
            <p
              className={`text-xs font-normal text-nowrap text-zi-blue-light/50 dark:text-white/50 ${
                isCollapsed && "opacity-0"
              }`}
            >
              {!isCollapsed ? "بخش مالی" : "."}
            </p>

            <Items
              svg_name="challenge"
              title="مدیریت حساب‌ها"
              isActive={activeIndex === 2}
              href="/accounts"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            <Items
              svg_name="transaction"
              title="مدیریت معاملات"
              isActive={activeIndex === 17}
              href="/trades"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            <Items
              svg_name="transaction"
              title="مدیریت تراکنش‌ها"
              isActive={activeIndex === 3}
              href="/transactions"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            <Items
              svg_name="sale"
              svg_classname={
                activeIndex === 18
                  ? "fill-white"
                  : "fill-zi-blue-dark dark:fill-white"
              }
              title="همکاری در فروش"
              isActive={activeIndex === 18}
              href="/sales-participation"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            <Items
              svg_name="challengeManage"
              title="مدیریت ‌چالش‌ها"
              isActive={activeIndex === 4}
              href="/challenges"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            <Items
              svg_name="dollar"
              title="مدیریت قیمت دلار"
              isActive={activeIndex === 19}
              href="/dollar"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
          </div>

          <div className="flex flex-col gap-3">
            <p
              className={`text-xs font-normal text-nowrap text-zi-blue-light/50 dark:text-white/50 ${
                isCollapsed && "opacity-0"
              }`}
            >
              {!isCollapsed ? "بخش مشتریان" : "."}
            </p>
            <Items
              svg_name="userManage"
              title="مدیریت مشتریان"
              isActive={activeIndex === 5}
              href="/customers"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            <Items
              svg_name="userKYC"
              title="احراز هویت مشتریان"
              isActive={activeIndex === 6}
              href="/kyc"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            <Items
              svg_name="userSupport"
              title="پشتیبانی مشتریان"
              isActive={activeIndex === 7}
              href="/support"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
              haveNotifications={haveNotifications}
              notificationCount={ticketCount}
            />
          </div>

          <div className="flex flex-col gap-3">
            <p
              className={`text-xs font-normal text-nowrap text-zi-blue-light/50 dark:text-white/50 ${
                isCollapsed && "opacity-0"
              }`}
            >
              {!isCollapsed ? "بخش هدایا" : "."}
            </p>
            <Items
              svg_name="discount"
              title="مدیریت کد تخفیف"
              isActive={activeIndex === 8}
              href="/coupons"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            {/* <Items
              svg_name="point"
              title="مدیریت امتیازات"
              isActive={activeIndex === 9}
              href="/Dashboard"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            <Items
              svg_name="competition"
              title="مدیریت مسابقات"
              isActive={activeIndex === 10}
              href="/Dashboard"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            /> */}
          </div>

          <div className="flex flex-col gap-3">
            <p
              className={`text-xs font-normal text-nowrap text-zi-blue-light/50 dark:text-white/50 ${
                isCollapsed && "opacity-0"
              }`}
            >
              {!isCollapsed ? "بخش محتوا" : "."}
            </p>
            <Items
              svg_name="notification"
              title="مدیریت اعلانات"
              isActive={activeIndex === 11}
              href="/announcements"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            {/* <Items
              svg_name="rules"
              title="مدیریت قوانین"
              isActive={activeIndex === 12}
              href="/rules"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            /> */}
            {/* <Items
              svg_name="blog"
              title="مدیریت بلاگ"
              isActive={activeIndex === 13}
              href="/blogs"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            /> */}
          </div>

          <div className="flex flex-col gap-3">
            <p
              className={`text-xs font-normal text-nowrap text-zi-blue-light/50 dark:text-white/50 ${
                isCollapsed && "opacity-0"
              }`}
            >
              {!isCollapsed ? "بخش مدیریتی" : "."}
            </p>
            <Items
              svg_name="profile"
              title="حساب کاربری"
              isActive={activeIndex === 14}
              href="/profile"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            <Items
              svg_name="managers"
              title="مدیران سامانه"
              isActive={activeIndex === 15}
              href="/admins"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            {/* <Items
              svg_name="log"
              title="لاگ سامانه"
              isActive={activeIndex === 16}
              href="/logs"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            /> */}
          </div>
        </div>
      </aside>
    </>
  );
}
